import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import $ from 'jquery';
import { throttle, isNaN, isFinite } from 'lodash';
import displayName from 'component-lib/displayName';

import RetinaImage from '../RetinaImage';

import styles from './VerticalScrollbar.scss';

import imageTopTop from './images/Scroll-Bar-Top-Icon.png';
import imageDownDown from './images/Scroll-Bar-Down-Icon.png';

import contextTypes from './ContextTypes';

// TODO: fix these files
/* globals document */
/* eslint-disable no-underscore-dangle */
export default class VerticalScrollbar extends Component {
    static displayName = displayName('VerticalScrollbar/VerticalScrollbar');

    static propTypes = {
        scrollbarHelper: PropTypes.object,
        setContextHelper: PropTypes.func,
        tableHelper: PropTypes.object,
        isScrollbarVisible: PropTypes.bool,
    };

    static contextTypes = contextTypes;

    static defaultProps = {
        scrollbarHelper: {},
        setContextHelper: () => {},
        tableHelper: null,
        isScrollbarVisible: false,
    };

    constructor(props, context) {
        super(props);

        this._calculateScrollPointerPosition = this._calculateScrollPointerPosition.bind(this);
        this._finishMoveScrollBar = this._finishMoveScrollBar.bind(this);
        this.__moveScrollBar = throttle(this._moveScrollBar.bind(this), 50);
        this.scrollPointerCenterModifier = 0;

        props.setContextHelper({
            onResize: this._reCalculatePositions,
            onTableScroll: this._calculateScrollPointerPosition,
            onTableChange: this._setScrollbarControlHeight,
        });

        this.state = {
            scrollBarControlHeight: 0,
            scrollPosition: 0,
            lastScrollBarPosition: 0,
            latestHistoryPosition: 0,
            beforeLatestHistoryPosition: 0,
            isLatestVisible: false,
            isBeforeLatestVisible: false,
            jumpToBottom: null,
        };

        this._tableHelper = props.tableHelper || context;
    }

    componentDidMount() {
        this.postComponentDidMount();
    }

    componentWillUpdate(nextProps, nextState) {
        const newNextState = nextState;

        newNextState.scrollBarControlHeight = this._setScrollbarControlHeight(true);
    }

    postComponentDidMount() {
        this.setState({
            scrollPosition: -this.scrollPointerCenterModifier,
        });
    }

    // Revisit later

    // scrollPointerCenterModifier: 0;
    // historyPointerCenterModifier: 0;
    // controllButtonsHeight: 0;
    // barControlMargin: 0;
    // _isCursorMoved: false;

    _setScrollbarControlHeight = (skipUpdate = false) => {
        const setScollbarUIHelpers = () => {
            this.scrollPointerCenterModifier = $(this.scrollPointer).outerHeight() / 2;
            this.historyPointerCenterModifier = $(this.latestHistoryPointer).outerHeight() / 2;
            /* eslint-disable react/no-string-refs */
            this.controllButtonsHeight = $(this.state.jumpToBottom).height() * 2;
            /* eslint-disable  react/no-string-refs */
            this.barControlMargin = parseInt($(this.scrollBarControl).css('marginTop'), 10) * 2 || 0;
        };

        let domNode;

        try {
            /* eslint-disable react/no-find-dom-node */
            domNode = findDOMNode(this);
            /* eslint-enable react/no-find-dom-node */
        } catch (e) {
            // probably unmounted
            return null;
        }

        const wrapperHeight = $(domNode).height();

        if (!this.controllButtonsHeight) setScollbarUIHelpers();

        if (wrapperHeight) {
            const scrollBarControlHeight =
        wrapperHeight - this.controllButtonsHeight - this.barControlMargin;

            if (skipUpdate) {
                return scrollBarControlHeight;
            }

            this.setState({ scrollBarControlHeight });
        }

        return null;
    };

    _reCalculatePositions = () => {
        let domNode;

        try {
            /* eslint-disable react/no-find-dom-node */
            domNode = findDOMNode(this);
            /* eslint-enable react/no-find-dom-node */
        } catch (e) {
            // this component is probably unmounted
            return;
        }

        const wrapperHeight = $(domNode).height();

        if (wrapperHeight > 0) {
            const {
                scrollBarControlHeight: originalScrollbarControlHeight,
                scrollPosition,
                latestHistoryPosition,
                beforeLatestHistoryPosition,
            } = this.state;

            const scrollBarControlHeight =
        wrapperHeight - this.controllButtonsHeight - this.barControlMargin;
            let modifier = scrollBarControlHeight / originalScrollbarControlHeight;
            let _scrollPosition = scrollPosition;

            if (isNaN(modifier) || !isFinite(modifier)) {
                if (this.scrollPointerCenterModifier) {
                    _scrollPosition = -this.scrollPointerCenterModifier;
                    modifier = 1;
                }
            }

            this.setState({
                scrollPosition: _scrollPosition * modifier,
                latestHistoryPosition: latestHistoryPosition * modifier,
                beforeLatestHistoryPosition: beforeLatestHistoryPosition * modifier,
                scrollBarControlHeight,
            });
        }
    };

    _calculateScrollPointerPosition = (valueInPercent) => {
        const { scrollBarControlHeight } = this.state;
        const scrollPosition =
      (scrollBarControlHeight * valueInPercent) - this.scrollPointerCenterModifier;

        this.setState({ scrollPosition });
    };

    _delegateScrollbarChange = () => {
        const { scrollPosition, scrollBarControlHeight } = this.state;
        const { onScrollbarScroll } = this._tableHelper;

        const scrollbarPosition = scrollPosition + this.scrollPointerCenterModifier;
        let valueInPercent = scrollbarPosition;

        if (scrollbarPosition !== 0) {
            valueInPercent = (scrollbarPosition / scrollBarControlHeight).toFixed(5);
        }

        onScrollbarScroll(valueInPercent);
    };

    _addMouseEventListeners() {
        document.addEventListener('mousemove', this.__moveScrollBar);
        document.addEventListener('mouseup', this._finishMoveScrollBar);
    }

    _removeMouseEventListeners() {
        document.removeEventListener('mousemove', this.__moveScrollBar);
        document.removeEventListener('mouseup', this._finishMoveScrollBar);
    }

    _onMouseDownScrollPointer = () => {
        const { scrollPosition } = this.state;

        this._isCursorMoved = false;
        this.setState({ lastScrollBarPosition: scrollPosition });

        this._removeMouseEventListeners();
        this._addMouseEventListeners();
    };

    _moveScrollBar({ clientY }) {
        const { bottom, height, top } = this.scrollBarControl.getBoundingClientRect();
        let newPosition;

        this._isCursorMoved = true;

        if (top <= clientY && clientY <= bottom) {
            newPosition = clientY - top;
        } else if (clientY > bottom) {
            newPosition = height;
        } else if (clientY < top) {
            newPosition = 0;
        }

        if (newPosition) {
            this.setState(
                {
                    scrollPosition: newPosition - this.scrollPointerCenterModifier,
                },
                () => this._delegateScrollbarChange(),
            );
        }
    }

    _finishMoveScrollBar() {
        this._removeMouseEventListeners();

        if (this._isCursorMoved) {
            this._setHistoryPositions();
        }
    }

    _setHistoryPositions() {
        const { isLatestVisible, latestHistoryPosition, lastScrollBarPosition } = this.state;

        this.setState({
            isLatestVisible: true,
            isBeforeLatestVisible: isLatestVisible,
            latestHistoryPosition: this._convertScrollPositionToHistory(lastScrollBarPosition),
            beforeLatestHistoryPosition: latestHistoryPosition,
        });
    }

    _setScrollPosition(newPosition, isChangeBeforeLatestPosition = true) {
        const { scrollPosition, lastScrollBarPosition } = this.state;

        this.setState(
            {
                lastScrollBarPosition: scrollPosition,
                scrollPosition: newPosition,
            },
            () => {
                this._delegateScrollbarChange();

                if (isChangeBeforeLatestPosition) {
                    this._setHistoryPositions();
                } else {
                    this.setState({
                        latestHistoryPosition: this._convertScrollPositionToHistory(lastScrollBarPosition),
                    });
                }
            },
        );
    }

    _convertScrollPositionToHistory(position) {
        return (position + this.scrollPointerCenterModifier) - this.historyPointerCenterModifier;
    }

    _convertHistoryPositionToScroll(position) {
        return (position + this.historyPointerCenterModifier) - this.scrollPointerCenterModifier;
    }

    _onClickScrollBar = ({ target, clientY }) => {
        const some = name => target.isEqualNode(this[name]);
        if (['scrollPointer', 'latestHistoryPointer', 'beforeLatestHistoryPointer'].some(some)) {
            return;
        }

        const { top } = this.scrollBarControl.getBoundingClientRect();

        this._setScrollPosition(clientY - top - this.scrollPointerCenterModifier);
    };

    _onClickJumpToTop = () => {
        this._setScrollPosition(0 - this.scrollPointerCenterModifier);
    };

    _onClickJumpToBottom = () => {
        const { scrollBarControlHeight } = this.state;

        this._setScrollPosition(scrollBarControlHeight - this.scrollPointerCenterModifier);
    };

    _onClickLatestHistoryPointer = () => {
        const { latestHistoryPosition } = this.state;

        this._setScrollPosition(this._convertHistoryPositionToScroll(latestHistoryPosition), false);
    };

    _onClickBeforeLatestHistoryPointer = () => {
        const { beforeLatestHistoryPosition } = this.state;

        this._setScrollPosition(this._convertHistoryPositionToScroll(beforeLatestHistoryPosition));
    };

    render() {
        const {
            scrollBarControlHeight,
            scrollPosition,
            isBeforeLatestVisible,
            beforeLatestHistoryPosition,
            isLatestVisible,
            latestHistoryPosition,
        } = this.state;

        const topIconProps = {
            onClick: this._onClickJumpToTop,
            'data-action': 'to-top',
            ref: (comp) => {
                if (!this.state.jumpToBottom) this.setState({ jumpToBottom: comp });
            },
        };

        const scrollbarControlProps = {
            ref: (c) => {
                this.scrollBarControl = c;
            },
            onClick: this._onClickScrollBar,
            className: styles['scroll-bar-control'],
            style: { height: scrollBarControlHeight || 0 },
        };

        const grayedScrollProps = {
            className: styles['grayed-scroll'],
        };

        const coloredScrollProps = {
            className: styles['colored-scroll'],
            style: { height: Math.max(0, scrollPosition || 0) },
        };

        const beforeLatestHistoryPointerProps = {
            ref: (c) => {
                this.beforeLatestHistoryPointer = c;
            },
            className: styles[isBeforeLatestVisible ? 'history-pointer' : 'hidden-history'],
            onClick: this._onClickBeforeLatestHistoryPointer,
            style: { top: beforeLatestHistoryPosition || 0 },
        };

        const latestHistoryPointerProps = {
            ref: (c) => {
                this.latestHistoryPointer = c;
            },
            className: styles[isLatestVisible ? 'history-pointer' : 'hidden-history'],
            onClick: this._onClickLatestHistoryPointer,
            style: { top: latestHistoryPosition || 0 },
        };

        const scrollPointerProps = {
            ref: (c) => {
                this.scrollPointer = c;
            },
            className: styles['scroll-pointer'],
            onMouseDown: this._onMouseDownScrollPointer,
            style: { top: scrollPosition || 0 },
        };

        const bottomIconProps = {
            'data-action': 'to-bottom',
            className: styles['jump-to-bottom'],
            onClick: this._onClickJumpToBottom,
        };

        const { isScrollbarVisible } = this.props;

        return (
            isScrollbarVisible && (
                <div className={`vertical-scroll-bar ${styles['vertical-scroll-bar']}`}>
                    <div {...topIconProps}>
                        <RetinaImage image={imageTopTop} />
                    </div>

                    <div {...scrollbarControlProps}>
                        <div {...grayedScrollProps} />
                        <div {...coloredScrollProps} />
                        <div {...beforeLatestHistoryPointerProps} />
                        <div {...latestHistoryPointerProps} />
                        <div {...scrollPointerProps} />
                    </div>

                    <div {...bottomIconProps}>
                        <RetinaImage image={imageDownDown} />
                    </div>
                </div>
            )
        );
    }
}
